import notify from "bootstrap-notify";

export default class AppHelper {
    /**
     * Function to check if variable is empty(null, undefined, '', 0, [], {})
     * @param mixedVar
     * @returns {boolean}
     */
    static empty(mixedVar){
        var key,i,len
        var emptyValues = [undefined, null, false, 0, '', '0', ' ']
        for (i = 0, len = emptyValues.length; i < len; i++) {
            if (mixedVar === emptyValues[i]) {
                return true
            }
        }
        if (typeof mixedVar === 'object') {
            for (key in mixedVar) {
                if (mixedVar.hasOwnProperty(key)) {
                    return false
                }
            }
            return true
        }
        return false
    }

    static notify(message, type, icon){
        $.notify({
            icon: icon,
            title: '',
            message: message,
            url: ''
        },{
            element: 'body',
            type: type,
            allow_dismiss: true,
            placement: {
                from: 'bottom',
                align: 'right'
            },
            offset: {
                x: 20,
                y: 20
            },
            spacing: 10,
            z_index: 1031,
            delay: 2500,
            timer: 1000,
            url_target: '_blank',
            mouse_over: false,
            animate: {
                enter: 'animated flipInX',
                exit: 'animated flipOutX'
            },
            template:   '<div data-notify="container" class="alert alert-dismissible alert-{0} alert--notify" role="alert">' +
            '<span data-notify="icon"></span> ' +
            '<span data-notify="title">{1}</span> ' +
            '<span data-notify="message">{2}</span>' +
            '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
            '</div>' +
            '<a href="{3}" target="{4}" data-notify="url"></a>' +
            '<button type="button" aria-hidden="true" data-notify="dismiss" class="alert--notify__close">X</button>' +
            '</div>'
        });
    }
}


import jQuery from "jquery"

(function($){
    $.fn.serializeFormData = function() {
        var form = $(this);
        var values = form.serializeArray();
        var data = {};
        if (values) {
            $(values).each(function(k,v){
                if(v.name in data && (typeof data[v.name] != 'object')) {
                    var element = form.find('[name="'+v.name+'"]');
                    //Only for muti select element we need to send array of values
                    if(element.is('select') && element.attr('multiple')!=undefined) {
                        var prevValue = data[v.name];
                        data[v.name] = new Array();
                        data[v.name].push(prevValue)
                    }
                }
                if(typeof data[v.name] == 'object' ) {
                    data[v.name].push(v.value);
                }else{
                    data[v.name]=v.value;
                }
            });
        }
        // If data-type="autocomplete", pickup data-value="..." set
        var autocompletes = $('[data-type="autocomplete"]', $(this));
        $(autocompletes).each(function(i){
            var ac = $(autocompletes[i]);
            data[ac.attr('name')] = ac.data('value');
        });
        return data;
    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/helper.js